import React, { useContext } from 'react'
import { AdminContext, TypeAdminContext } from '../contexts'

const useAdmin = (): TypeAdminContext => {
    return useContext(AdminContext)
}

export default useAdmin
